import type { Config } from "tailwindcss";

const config: Config = {
  future: {
    hoverOnlyWhenSupported: true,
  },
  content: [
    "./src/pages/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/components/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/components-lib/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/app/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/utils/**/*.{js,ts,jsx,tsx,mdx}",
  ],
  theme: {
      extend: {
        colors: {
          primary: "rgba(var(--color-primary), 1)", 
          secondary:  "rgba(var(--color-secondary), 1)", 
          accent:  "rgba(var(--color-accent), 1)", 
          light:  "rgba(var(--color-light), 1)", 
          dark:  "rgba(var(--color-dark), 1)", 
          white:  "rgba(var(--color-white), 1)",
          lightGray:  "rgba(var(--color-lightGray), 1)",
          translucentWhite: "rgba(var(--color-translucentWhite), 1)", 
        },
        fontFamily: {
          essonnes: ['var(--font-family-essonnes)'],
          greycliff: ['var(--font-family-greycliff)'],
          inter: ['var(--font-family-inter)']
        },
        fontWeight: {
          thin: '100',
          extralight: '200',
          light: '300',
          normal: '400',
          medium: '500',
          semibold: '600',
          bold: '700',
          extrabold: '800',
          black: '900'
        },
        fontSize: {
          xs: "var(--font-size-xs)",
          sm: "var(--font-size-sm)",
          base: "var(--font-size-base)",
          lg: "var(--font-size-lg)",
          xl: "var(--font-size-xl)",
          "2xl": "var(--font-size-2xl)",
          "4xl": "var(--font-size-4xl)",
          "5xl": ["var(--font-size-5xl)", { lineHeight: "var(--line-height-tighter)" }],
          "6xl": ["var(--font-size-6xl)", { lineHeight: "var(--line-height-tighter)" }],
          "8xl": "var(--font-size-8xl)",
        },
        borderRadius: {
          lg: "var(--border-radius-lg)",
          xl: "var(--border-radius-xl)",
          "2xl": "var(--border-radius-2xl)",
          "rounded-circle": "var(--border-radius-rounded-circle)",
        },
        opacity: {
          10: "var(--opacity-10)",
          25: "var(--opacity-25)",
          40: "var(--opacity-40)",
          70: "var(--opacity-70)",
          90: "var(--opacity-90)",
        },
        spacing: {
          px: "var(--spacing-px)",
          7: "var(--spacing-7)",
          9: "var(--spacing-9)",
          11: "var(--spacing-11)",
          14: "var(--spacing-14)",
          61: "var(--spacing-61)",
          70: "var(--spacing-70)",
          400: "var(--spacing-400)",
        },
        lineHeight: {
          tight: "var(--line-height-tighter)",
          normal: "var(--line-height-normal)",
          loose: "var(--line-height-loose)",
          tighter: "var(--line-height-tighter)",
        },
        letterSpacing: {
          tight: "var(--letter-spacing-tight)",
          wider: "var(--letter-spacing-wider)",
        },
        screens: {
          '3xl': '1920px',
        },
      },
  },
  plugins: [],
};
export default config;
